import axiosInstance from "../axiosInstance";

export const GETOperacionEnProceso = async () => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_WMS_BASE_URL}/ordenes/operacion-en-proceso`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message ||
        "Error al verificar operaciones en proceso",
    };
  }
};

export default GETOperacionEnProceso;
